import { AuthorizationChildNode } from './../models/authorization.child-node';
import { AuthorizationTree } from './../models/authorization.tree';
import { Authorization } from './../models/authorization';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApi } from 'app/auth/rest.api';
import { DateUtil } from 'app/core/utils/DateUtil';

@Injectable()
export class AuthorizationService {
    authorizationUrl = 'api/authorization';
    constructor(private _authHttp: RestApi) { }

    getParentsTree(): Observable<AuthorizationTree[]> {
        return this._authHttp.get(`${this.authorizationUrl}`);
    }

    getAuthorizationDetail(type: string, subType: string, nodeId: Guid): Observable<IAuthorizationDetail> {
        if(!subType || subType === '') {
            return this._authHttp.get(`${this.authorizationUrl}/${type}/${nodeId}/`);
        }
        else {
            return this._authHttp.get(`${this.authorizationUrl}/${type}/${subType}/${nodeId}/`);
        }
    }

    getChildNodesByType(type: string): Observable<AuthorizationChildNode[]> {
        return this._authHttp.get(`${this.authorizationUrl}/${type}/`);
    }

    putDataDetail(type: string, id: Guid, body: any): Observable<any> {
        return this._authHttp.post(`${this.authorizationUrl}`, body);
    }

    isAuthorizationReportDisabled(): Observable<boolean> {
        return this._authHttp.get(`${this.authorizationUrl}/IsReportDisabled`);
    }

    downloadReport(): Observable<any> {
        return this._authHttp.requestBlob(
            {
                url: `${this.authorizationUrl}/DownloadReport`,
                parameters: [],
                body: "AuthorizationReport.csv"
            }, 'POST')
            .map(result => {
                const formattedDate = DateUtil.formatDateLarge(new Date());
                const fileName: string = `AuthorizationReport_${formattedDate}.csv`;
                const fileUrl = (window.URL || window['webkitURL']).createObjectURL(new Blob([result.body], { type: 'application/octet-stream' }));
                const anchor = document.createElement('a');
                anchor.download = fileName;
                anchor.href = fileUrl;
                anchor.click();
            });        
    }
}
